module.exports = __webpack_public_path__ + "img/newstitle.c653685e.png";